import { useMutation } from "@tanstack/react-query";
import { useChosenDepartment } from "@/contexts/ChosenDepartment";
import { useErrorSnackbar } from "@/hooks/useErrorSnackbar";
import { backendService } from "@/services/backend.service";

/**
 * Persist the department-level opt-out of the over-staffing warning (the dialog's "don't show again"
 * checkbox) and reflect it locally so the warning stops firing immediately — see [[useStaffingTargetCheck]],
 * which short-circuits on `chosenDepartment.hideOverstaffingWarning`.
 */
export const useDismissOverstaffingWarning = () => {
	const { chosenDepartment, setChosenDepartment } = useChosenDepartment();
	const showErrorSnackbar = useErrorSnackbar();

	return useMutation({
		mutationFn: () => backendService.setHideOverstaffingWarning(chosenDepartment.department_id, true),
		throwOnError: false,
		onSuccess: () => {
			setChosenDepartment((prev) => ({ ...prev, hideOverstaffingWarning: true }));
		},
		onError: (error) => {
			showErrorSnackbar("Failed to save warning preference", {}, error);
		},
	});
};
